import React from "react";
import { Form } from "react-bootstrap";

type Props = { message?: string };

const FieldError: React.FC<Props> = (props: Props) => {
	const { message = "" } = props;

	return (
		<>
			<Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>
		</>
	);
};

export default FieldError;
